import React from 'react'
import {useLocation} from 'react-router-dom';

export const Whatsapp = () => {
  const location = useLocation();
  
  if (location.pathname.includes("article-details")) {
    return null;
  }
  return (
    <div className="relative">
      <a
        href="https://api.whatsapp.com/send/?phone=919315265493&amp;text=Hello!+Preview+Tax,+I+want+to+know+more+about+your+services"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with Preview Tax on WhatsApp"
        className="fixed bottom-3 left-5 z-40 transform hover:text-green-700 text-green-500 p-3 hover:scale-110 transition-transform"
      >
        <img src="/wp_icon.webp" alt="WhatsApp Icon" className="w-16 h-16" />
      </a>
    </div>
  )
}
